angular.module('jv.candidates.service', ['App.ajax.service'])
    .factory('jvCandidatesServiceConstant', ['$window', '$jobviteUrls', function($window, $jobviteUrls) {
        return {
            Urls: {
                // Actions Menu
                "moveCandidate": $jobviteUrls.jhire + '/action/applications',
                "getRequistionFilters":$jobviteUrls.jhire + '/action/requisitions/filters?',
                "addToCollection": $jobviteUrls.jhire + '/action/application/collection/add',
                "changeStatus" : $jobviteUrls.jhire + '/action/application/list/changestatus',
                "getChangeStatus" : $jobviteUrls.jhire + '/action/requisition/{0}/workflow/changestatus',
                "getNextStatusChange" : $jobviteUrls.jhire + '/action/requisition/{0}/workflow/changestatus/{1}',
                "sendMessage": $jobviteUrls.jhire + '/action/applications/list/message',
                "bulkSelfSchedule": $jobviteUrls.jhire + '/action/application/list/requestAvailability',
                "sendSMSMessage": $jobviteUrls.jhire + '/action/applications/list/sms',
                "seekConsent": $jobviteUrls.jhire + '/action/applications/list/seekConsent',
                "validateCandidateDetails": $jobviteUrls.jhire + '/action/application/list/{0}/validate?{1}',
                "validateCandidatePhoneDetails": $jobviteUrls.jhire + '/action/application/list/sendSMSMessage/validate',
                "phoneList": $jobviteUrls.jhire + '/action/application/sendSMSMessage/phoneList',
                "rejectCandidateDetails": $jobviteUrls.jhire + '/action/application/{0}/reject',
                "rejectCandidateDetailsBulk": $jobviteUrls.jhire + '/action/application/template/reject?{0}',
                "rejectCandidateDetailsBulkPost": $jobviteUrls.jhire + '/action/application/list/reject',
                "rejectMoveCandidateBulkPost": $jobviteUrls.jhire + '/action/applications/move/{0}',
                "deleteCandidate": $jobviteUrls.jhire + '/action/application/list',
                "shareApplication": $jobviteUrls.jhire + '/action/application/{0}/share',
                "sendNoteTemplate": $jobviteUrls.jhire + '/action/application/template/SendNotes',
                'sendNote': $jobviteUrls.jhire + '/action/applications/list/note?readMode=0',
                "getSubmitToHMTemplateForCandidate": $jobviteUrls.jhire + '/action/application/{0}/state/{1}/submitHM',
                "getSubmitToHMTemplateForCandidates": $jobviteUrls.jhire + '/action/application/template/{0}/submitToHM?{1}',
                "submitCandidateToHM": $jobviteUrls.jhire + '/action/application/list/{0}/submitHM?readMode=0',
                "addCandidate": $jobviteUrls.jhire + '/action/application/list/addCandidate',
                "getWorkflowDetails": $jobviteUrls.jhire + '/action/application/{0}/workflowState/{1}',
                "getApplicationDetails": $jobviteUrls.jhire + '/action/application/{0}/details',
                "getContactInfoForCandidate": $jobviteUrls.source + '/action/person/contactDetailsPage?action=getContactInfoForCandidate',
                "getCandidateDetailsForApplication": $jobviteUrls.jhire + '/action/application/{0}/candidateDetails?',
                "getCandidateApplications" : $jobviteUrls.jhire + '/action/application/{0}/applications',
                "getCandidateFeed" : $jobviteUrls.jhire + '/action/application/{0}/getFeeds',
                "fetchFeedDetail" : $jobviteUrls.jhire + '/action/application/{0}/applicationMessage/{1}',
                "getWorkflowUpdates": $jobviteUrls.jhire + '/action/application/{0}/workflowUpdates',
                "searchCandidates": $jobviteUrls.jhire + '/action/candidates/search',
                "searchApplications": $jobviteUrls.jhire + '/action/application/search',
                "getApplicationsCount": $jobviteUrls.jhire + '/action/application/search/count',
                "uploadEsigOffer": $jobviteUrls.jhire + '/action/application/{0}/uploadESigOffer',
                "getCustomApplicationTemplate": $jobviteUrls.jhire + '/action/application/{0}/userEmailTemplate/{1}',
                "getCustomTemplate": $jobviteUrls.jhire + '/action/application/userEmailTemplate/{0}',
                "sendToOnboarding": $jobviteUrls.jhire + '/action/application/{0}/state/{1}/onboarding?readMode=0',
                "getOnboardingStatus": $jobviteUrls.jhire + '/action/application/{0}/state/{1}/onboarding',
                "stopOnboarding": $jobviteUrls.jhire + '/action/application/{0}/state/{1}/onboarding/{2}/retract',
                "getEducationAndWorkHistory": $jobviteUrls.jhire + '/action/application/{0}/workAndEducation',
                "saveWorkHistory": $jobviteUrls.jhire + '/action/application/{0}/workHistory/save',
                "saveEducationHistory": $jobviteUrls.jhire + '/action/application/{0}/educationHistory/save',
                "saveCandidateTabOrder": $jobviteUrls.jhire + "/action/user/candidateTabOrder/save",
                "likeFeed": $jobviteUrls.jhire + '/action/application/{0}/{1}/toggleLike',
                "commentFeed": $jobviteUrls.jhire + '/action/application/{0}/{1}/comment',
                "deleteComment": $jobviteUrls.jhire + '/action/application/{0}/feed/{1}/comment/{2}',
                "getComments": $jobviteUrls.jhire + '/action/application/{0}/{1}/comments',
                "userSearch": $jobviteUrls.admin + '/action/user/search',
                "sharePost": $jobviteUrls.jhire + '/action/application/{0}/sharePost',
                "getCollabTeamUsers" : $jobviteUrls.jhire + '/action/application/{0}/collabTeam',
                "deleteCollabTeamUsers" : $jobviteUrls.jhire + '/action/application/{0}/collabTeam/delete?users={1}',
                "getMessages" : $jobviteUrls.jhire + '/action/application/{0}/messages?offset=0&count=10',
                "getNotes" : $jobviteUrls.jhire + '/action/application/{0}/notes?offset=0&count=10',
                "validateMoveModal" : $jobviteUrls.jhire + '/action/application/{0}/moveAcrossWorkflows/{1}',
                'offerReject': $jobviteUrls.jhire +'/action/application/{0}/offerreject/{1}/{2}',
                'getApplicationSummary': $jobviteUrls.jhire +'/action/application/{0}/summary',
                'CommunicationCount': $jobviteUrls.jhire +'/action/application/{0}/communication/count',
                'unlinkLinkedInProfile' : $jobviteUrls.jhire  + '/action/modules/candidates/unLinkLinkedInProfile?applicationId={0}&candidateEid={1}&memberToken={2}&unlink={3}',
                'linkedInCandidateSyncStatus' : $jobviteUrls.jhire  + '/action/modules/candidates/candidateSyncStatus?applicationId={0}&candidateEId={1}',
                'syncCandidateToLinkedIn' : $jobviteUrls.jhire  + '/action/modules/candidates/syncCandidateToLinkedIn?applicationId={0}&contactEId={1}',
                'getCoverPageDetails': $jobviteUrls.jhire + '/action/application/{0}/native-esign/cover-page',
                'getCoverPageFile': $jobviteUrls.jhire + '/action/application/{0}/native-esign-coverpage',
            }
        };
    }])
    .service('jvCandidatesService', ['$window', '$q', 'makeAjaxCall', 'jvCandidatesServiceConstant',
        function($window, $q, makeAjaxCall, jvCandidatesServiceConstant) {

            var candidatesService = {};

            /**
             *  Utility for calling the ajax functions.
            */
            function createRequestObject(args, callback, options) {
                callback = (callback || angular.noop);
                var requestObj = args || {};
                requestObj.ajaxtype = options.ajaxtype;
                requestObj.url = options.url;
                requestObj.requestType = options.requestType || "GET";
                requestObj.cache = options.cache || false;
                var requestPromise = makeAjaxCall(requestObj);
                return requestPromise.then(function(results) {
                    callback(results);
                    return results;
                }, function(results) {
                    callback(results);
                });
            }

            var checkParmsForJquery = function(params) {
                if (jQuery.fn.jquery.split('.')[0] === '3') {
                    return $.param(params, true);
                } else {
                    return $.param(params);
                }
            };

            // For POST-ing the user workflow
            candidatesService.moveCandidate = function(args, callback) {
                var options = {
                    'ajaxtype': 'moveCandidate',
                    'url': jvCandidatesServiceConstant.Urls.moveCandidate+'/'+args.destinationJobId +'/move/'+ args.sourceJobId,
                    'requestType': 'POST'
                };
                delete args.destinationJobId;
                delete args.sourceJobId;
                var applicationList = args.data;
                args = applicationList;
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            candidatesService.rejectCandidateDetails = function(args, callback) {
                if (!args.appId) {
                    return;
                }
                var options = {
                    'ajaxtype': 'rejectCandidateDetails',
                    'url': jvCandidatesServiceConstant.Urls.rejectCandidateDetails.format(args.appId),
                    'requestType': 'GET'
                };

                delete args.appId;
                createRequestObject(args, callback, options);
            };

            //@i18N: applicationEIds to be sent to BE to decide Set of Langugaes for Template group{parent-child} list
            candidatesService.rejectCandidateDetailsBulk = function(qsParams, args, callback) {
                var options = {
                    'ajaxtype': 'rejectCandidateDetailsBulk',
                    'url': jvCandidatesServiceConstant.Urls.rejectCandidateDetailsBulk.format(checkParmsForJquery(qsParams)),
                    'requestType': 'GET'
                };

                createRequestObject(args, callback, options);
            };


            candidatesService.rejectCandidate = function(args, callback) {
                if (!args.appId && !args.bulk) {
                    return;
                }

                var options = {
                    'ajaxtype': 'rejectCandidate',
                    'requestType': 'POST'
                };

                if (args.bulk) {
                        options.url = args.moveCandidateEnabled ? jvCandidatesServiceConstant.Urls.rejectCandidateDetailsBulkPost : jvCandidatesServiceConstant.Urls.rejectMoveCandidateBulkPost.format(args.destinationJobId);
                } else {
                    options.url = args.moveCandidateEnabled ? jvCandidatesServiceConstant.Urls.rejectCandidateDetails.format(args.appId): jvCandidatesServiceConstant.Urls.rejectMoveCandidateBulkPost.format(args.destinationJobId) ;
                    delete args.destinationJobId;
                    delete args.moveCandidateEnabled;
                    delete args.appId;
                }

                delete args.bulk;
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };


            candidatesService.changeStatus = function(args, callback) {
                var options = {
                    'ajaxtype': 'changeStatus',
                    'url': jvCandidatesServiceConstant.Urls.changeStatus,
                    'requestType': 'POST'
                };

                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            candidatesService.getChangeStatus = function(args, callback) {
                if (!args.reqId) {
                    return;
                }

                var options = {
                    'ajaxtype': 'getChangeStatus',
                    'url': jvCandidatesServiceConstant.Urls.getChangeStatus.format(args.reqId),
                };

                delete args.reqId;
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            candidatesService.getNextStatusChange = function(args, callback) {
                if (!args.reqId && !args.currentStatus) {
                    return;
                }

                var options = {
                    'ajaxtype': 'getNextStatusChange',
                    'url': jvCandidatesServiceConstant.Urls.getNextStatusChange.format(args.reqId, args.currentStatus),
                };

                delete args.reqId;
                delete args.currentStatus;
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            candidatesService.addToCollection = function(args, callback) {
                var options = {
                    'ajaxtype': 'addToCollection',
                    'url': jvCandidatesServiceConstant.Urls.addToCollection,
                    'requestType': 'POST'
                };

                //PRANAV: Need to fix this. Should be just a configuration and not having to do this everytime. Need to make ajaxservice easier to use.
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            candidatesService.seekConsent = function(args, callback) {
                var options = {
                    'ajaxtype': 'seekConsent',
                    'url': jvCandidatesServiceConstant.Urls.seekConsent,
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            candidatesService.sendMessage = function(args, callback) {
                var options = {
                    'ajaxtype': 'sendMessage',
                    'url': jvCandidatesServiceConstant.Urls.sendMessage,
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            candidatesService.bulkSelfSchedule = function(args, callback) {
                var options = {
                    'ajaxtype': 'bulkSelfSchedule',
                    'url': jvCandidatesServiceConstant.Urls.bulkSelfSchedule,
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            candidatesService.sendSMSMessage = function(args, callback) {
                var options = {
                    'ajaxtype': 'sendMessage',
                    'url': jvCandidatesServiceConstant.Urls.sendSMSMessage,
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            // For validating user emails and agency email ids
            candidatesService.validateCandidateDetails = function(args, callback) {
                var deliveryMethod = args.deliveryMethod ? 'deliveryMethod=' + args.deliveryMethod : '';

                var options = {
                    'ajaxtype': 'validateCandidateDetails',
                    'url': jvCandidatesServiceConstant.Urls.validateCandidateDetails.format(args.action, deliveryMethod),
                    'requestType': 'POST'
                };
                var applicationList = args.data;
                args = applicationList;
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            // For checking if the user have phone numbers
            candidatesService.getPhoneNoList = function(args, callback) {
                var options = {
                    'ajaxtype': 'phoneList',
                    'url': jvCandidatesServiceConstant.Urls.phoneList,
                    'requestType': 'GET'
                };
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            // For checking if the candidates have phone numbers
            candidatesService.validateCandidatePhoneDetails = function(args, callback) {
                var options = {
                    'ajaxtype': 'validateCandidatePhoneDetails',
                    'url': jvCandidatesServiceConstant.Urls.validateCandidatePhoneDetails,
                    'requestType': 'POST'
                };
                var applicationList = args.data;
                args = applicationList;
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            candidatesService.deleteCandidate = function(args, gdprEnabled,anonymize, callback) {
                var options = {
                    'ajaxtype': 'deleteCandidate',
                    'url': jvCandidatesServiceConstant.Urls.deleteCandidate,
                    'requestType': 'DELETE'
                };

                if(gdprEnabled){
                    options.url =  options.url+"?anonymize=" + anonymize;
                }
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            candidatesService.shareApplication = function(args, callback) {
                var options = {
                    'ajaxtype': 'shareApplication',
                    'url': jvCandidatesServiceConstant.Urls.shareApplication.format(args.applicationEIds),
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };


            //@i18N: applicationEIds to be sent to BE to decide Set of Langugaes for Template group{parent-child} list
            candidatesService.sendNoteTemplate = function(qsParams, args, callback) {
                var options = {
                    'ajaxtype': 'sendNoteTemplates',
                    'url': jvCandidatesServiceConstant.Urls.sendNoteTemplate + '?{0}'.format($.param(qsParams)),
                    'requestType': 'GET'
                };
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };


            candidatesService.sendNote = function(args, callback) {
                var options = {
                    'ajaxtype': 'sendNotePost',
                    'url': jvCandidatesServiceConstant.Urls.sendNote,
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            //Get submit to HM Templates
            candidatesService.getSubmitToHMTemplateForCandidate = function(args, callback) {
                var options = {
                    'ajaxtype': 'getSubmitToHMTemplateForCandidate',
                    'requestType': 'GET'
                };
                if(args.bulk){
                    //@i18N: applicationEIds to be sent to BE to decide Set of Langugaes for Template group{parent-child} list
                    options.url =  jvCandidatesServiceConstant.Urls.getSubmitToHMTemplateForCandidates.format(args.jobId, $.param(args.applicationEIds));
                    delete args.jobId;
                    delete args.bulk;
                }else{
                    options.url =  jvCandidatesServiceConstant.Urls.getSubmitToHMTemplateForCandidate.format(args.applicationId,args.stateId);
                    delete args.applicationId;
                    delete args.stateId;
                }
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            //Submitting candidate to hiring manager
            candidatesService.submitCandidateToHM = function(stateId, args, callback) {
                var options = {
                    'ajaxtype': 'submitCandidateToHM',
                    'requestType': 'POST',
                    'url': jvCandidatesServiceConstant.Urls.submitCandidateToHM.format(stateId)
                };
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            //Get Requistion Filters
            candidatesService.getRequistionFilters = function(args, callback) {
                var options = {
                    'ajaxtype': 'getRequistionFilters',
                    'url': jvCandidatesServiceConstant.Urls.getRequistionFilters,
                    'requestType': 'GET'
                };
                createRequestObject(args, callback, options);
            };

            //Add Candidate to requisition
            candidatesService.addCandidate = function(args, callback) {
                var options = {
                    'ajaxtype': 'addCandidate',
                    'requestType': 'POST',
                    'url': jvCandidatesServiceConstant.Urls.addCandidate
                };
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            //Redirect to Scheduler page
            candidatesService.redirectToScheduler = function(args, callback){
                var options = {
                    'ajaxtype': 'getWorkflowDetails',
                    'url': jvCandidatesServiceConstant.Urls.getWorkflowDetails,
                    'requestType': 'GET'
                };
                options.url =  jvCandidatesServiceConstant.Urls.getWorkflowDetails.format(args.applicationId,args.stateId);
                createRequestObject(args, callback, options);
            };


            candidatesService.getApplicationDetails = function(args, callback){
                var options = {
                    'ajaxtype': 'getApplicationDetails',
                    'url': jvCandidatesServiceConstant.Urls.getApplicationDetails,
                    'requestType': 'GET'
                };
                options.url =  jvCandidatesServiceConstant.Urls.getApplicationDetails.format(args.applicationId);
                delete args.applicationId;
                createRequestObject(args, callback, options);
            };

            candidatesService.getContactInfoForCandidate = function(args, callback) {
                var options = {
                    'ajaxtype': 'getContactInfoForCandidate',
                    'url': jvCandidatesServiceConstant.Urls.getContactInfoForCandidate,
                    'requestType': 'GET'
                };
                createRequestObject(args, callback, options);
            };

            candidatesService.getCandidateDetailsForApplication = function(args, callback) {
                var options = {
                    'ajaxtype': 'getCandidateDetailsForApplication',
                    'url': jvCandidatesServiceConstant.Urls.getCandidateDetailsForApplication.format(args.applicationId),
                    'requestType': 'GET'
                };
                delete args.applicationId;
                createRequestObject(args, callback, options);
            };

            candidatesService.getEducationAndWorkHistory = function(args, callback) {
                var options = {
                    'ajaxtype': 'getEducationAndWorkHistory',
                    'url': jvCandidatesServiceConstant.Urls.getEducationAndWorkHistory.format(args.applicationId),
                    'requestType': 'GET'
                };
                delete args.applicationId;
                createRequestObject(args, callback, options);
            };

            //Get all applications for an application
            candidatesService.getCandidateApplications = function(args, callback) {
                var options = {
                    'ajaxtype': 'getCandidateApplications',
                    'url': jvCandidatesServiceConstant.Urls.getCandidateApplications.format(args.applicationId),
                    'requestType': 'GET'
                };
                delete args.applicationId;
                createRequestObject(args, callback, options);
            };

            //Get all collab team users
            candidatesService.getCollabTeamUsers = function(args, callback) {
                var options = {
                    'ajaxtype': 'getCollabTeamUsers',
                    'url': jvCandidatesServiceConstant.Urls.getCollabTeamUsers.format(args.applicationId),
                    'requestType': 'GET'
                };
                delete args.applicationId;
                createRequestObject(args, callback, options);
            };

            //Delete collab team users
            candidatesService.deleteCollabTeamUsers = function(args, callback) {
                var options = {
                    'ajaxtype': 'deleteCollabTeamUsers',
                    'url': jvCandidatesServiceConstant.Urls.deleteCollabTeamUsers.format(args.applicationId,args.userIds),
                    'requestType': 'POST'
                };
                delete args.applicationId;
                delete args.userIds;
                createRequestObject(args, callback, options);
            };


            candidatesService.getCandidateFeed = function(args, callback) {
                var options = {
                    'ajaxtype': 'getCandidateFeed',
                    'url': jvCandidatesServiceConstant.Urls.getCandidateFeed.format(args.applicationId),
                    'requestType': 'GET'
                };
                delete args.applicationId;
                createRequestObject(args, callback, options);
            };

            candidatesService.fetchFeedDetail = function(args, callback) {
                var options = {
                    'ajaxtype': 'fetchFeedDetail',
                    'url': jvCandidatesServiceConstant.Urls.fetchFeedDetail.format(args.applicationId,args.objectEId),
                    'requestType': 'GET'
                };
                delete args.applicationId;
                delete args.objectEId;
                createRequestObject(args, callback, options);
            };

            candidatesService.getWorkflowUpdates = function(args, callback) {
                var options = {
                    'ajaxtype': 'getWorkflowUpdates',
                    'url': jvCandidatesServiceConstant.Urls.getWorkflowUpdates.format(args.applicationId),
                    'requestType': 'GET'
                };
                delete args.applicationId;
                createRequestObject(args, callback, options);
            };

            candidatesService.searchCandidates = function(args, callback) {
                var options = {
                    'ajaxtype': 'searchCandidates',
                    'url': jvCandidatesServiceConstant.Urls.searchCandidates,
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type':'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            candidatesService.searchApplications = function(args, callback) {
                var options = {
                    'ajaxtype': 'searchApplications',
                    'url': jvCandidatesServiceConstant.Urls.searchApplications,
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type':'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            candidatesService.getApplicationsCount = function(args, callback) {
                var options = {
                    'ajaxtype': 'getAplicationsCount',
                    'url': jvCandidatesServiceConstant.Urls.getApplicationsCount,
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type':'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            //POST eSig offer Letter
            candidatesService.uploadEsigOfferLetter = function(args, callback){
                var options = {
                    'ajaxtype': 'uploadEsigOffer',
                    'url': jvCandidatesServiceConstant.Urls.uploadEsigOffer.format(args.applicationEId),
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
                delete args.applicationEId;
                createRequestObject(args, callback, options);
            };

            candidatesService.getCustomMessageTemplate = function(applicationId, templateId, data) {
                var url = jvCandidatesServiceConstant.Urls.getCustomTemplate.format(templateId);
                if (applicationId) {
                    url = jvCandidatesServiceConstant.Urls.getCustomApplicationTemplate.format(applicationId, templateId);
                }
                var options = {
                    ajaxtype: 'getCustomTemplate',
                    url: url
                };
                return createRequestObject(data, angular.noop, options);
            };

            //send to Jobvite-Onboarding
            candidatesService.sendToOnboarding = function(args, callback){
                var options = {
                        'ajaxtype': 'sendToOnboarding',
                        'url': jvCandidatesServiceConstant.Urls.sendToOnboarding.format(args.applicationEId, args.workflowStateEId),
                        'requestType': 'PUT'
                 };
                 args.headers = {'Content-Type':'application/json; charset=UTF-8'};
                 delete args.applicationEId;
                 delete args.workflowStateEId;
                 createRequestObject(args, callback, options);
            };

            //Get Onboarding status
            candidatesService.getOnboardingStatus = function(args, callback){
                var options = {
                        'ajaxtype': 'getOnboardingStatus',
                        'url': jvCandidatesServiceConstant.Urls.getOnboardingStatus.format(args.applicationEId, args.workflowStateEId),
                        'requestType': 'GET'
                 };
                 args.headers = {'Content-Type':'application/json; charset=UTF-8'};
                 delete args.applicationEId;
                 delete args.workflowStateEId;
                 createRequestObject(args, callback, options);
            };

            //stop Jobvite-Onboarding
            candidatesService.retractJobviteOnboarding = function(args, callback){
                var options = {
                        'ajaxtype': 'stopOnboarding',
                        'url': jvCandidatesServiceConstant.Urls.stopOnboarding.format(args.applicationEId, args.workflowStateEId, args.newHireId),
                        'requestType': 'POST'
                 };
                 args.headers = {'Content-Type':'application/json; charset=UTF-8'};
                 delete args.applicationEId;
                 delete args.workflowStateEId;
                 delete args.newHireId;
                 createRequestObject(args, callback, options);
            };


            //save workHistory
            candidatesService.saveWorkHistory = function(args,callback) {
                var options = {
                    'ajaxtype': 'saveWorkHistory',
                    'url': jvCandidatesServiceConstant.Urls.saveWorkHistory.format(args.applicationId),
                    'requestType': 'POST'
                };
                delete args.applicationId;
                var workHistory = args.postData;
                args = workHistory;
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            // For moving the candidate for same workflow
            candidatesService.moveCandidateForSameWorkflow = function(args, callback) {
                var options = {
                    'ajaxtype': 'moveCandidateForSameWorkflow',
                    'url': jvCandidatesServiceConstant.Urls.moveCandidate+'/'+args.destinationJobId +'/move',
                    'requestType': 'POST'
                };
                delete args.destinationJobId;
                var applicationList = args.data;
                args = applicationList;
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };


            //save educationHistory
            candidatesService.saveEducationHistory = function(args,callback) {
                var options = {
                    'ajaxtype': 'saveEducationHistory',
                    'url': jvCandidatesServiceConstant.Urls.saveEducationHistory.format(args.applicationId),
                    'requestType': 'POST'
                };
                delete args.applicationId;
                var educationHistory = args.postData;
                args = educationHistory;
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };


            //save educationHistory
            candidatesService.saveCandidateTabOrder = function(args,callback) {
                var options = {
                    'ajaxtype': 'saveCandidateTabOrder',
                    'url': jvCandidatesServiceConstant.Urls.saveCandidateTabOrder,
                    'requestType': 'POST'
                };
                var tabSet = args.postData;
                args = tabSet;
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            // like a feed
            candidatesService.likeFeed = function(args, callback) {
                var options = {
                    'ajaxtype': 'likeFeed',
                    'url': jvCandidatesServiceConstant.Urls.likeFeed.format(args.targetEId,args.feedOid),
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type':'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            // comment on a feed
            candidatesService.commentFeed = function(args, callback) {
                var options = {
                    'ajaxtype': 'commentFeed',
                    'url': jvCandidatesServiceConstant.Urls.commentFeed.format(args.targetEId,args.feedOid),
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type':'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            // get list of comments of a feed
            candidatesService.getComments = function(args, callback){
            	var options = {
                    'ajaxtype': 'getComments',
                    'url': jvCandidatesServiceConstant.Urls.getComments.format(args.applicationEId, args.feedOid),
                    'requestType': 'GET'
                 };
                 args.headers = {'Content-Type':'application/json; charset=UTF-8'};
                 createRequestObject(args, callback, options);
            };

            candidatesService.deleteComment = function(args, callback){
            	var options = {
	                'ajaxtype': 'deleteComment',
	                'url': jvCandidatesServiceConstant.Urls.deleteComment.format(args.applicationEId, args.feedOid, args.commentOid),
	                'requestType': 'DELETE'
	             };
	             args.headers = {'Content-Type':'application/json; charset=UTF-8'};
	             createRequestObject(args, callback, options);
            }

            candidatesService.sharePost = function(id, args, callback){
            	var options = {
	                'ajaxtype': 'sharePost',
	                'url': jvCandidatesServiceConstant.Urls.sharePost.format(id),
	                'requestType': 'POST'
	             };
	             args.headers = {'Content-Type':'application/json; charset=UTF-8'};
	             createRequestObject(args, callback, options);
            }

            // get user objects
            candidatesService.userSearch = function(args, callback){
            	var options = {
                        'ajaxtype': 'getUserObjects',
                        'url': jvCandidatesServiceConstant.Urls.userSearch,
                        'requestType': 'GET'
                     };
                     args.headers = {'Content-Type':'application/json; charset=UTF-8'};
                     createRequestObject(args, callback, options);
            }

            // get messages
            candidatesService.getMessages = function(args, callback){
            	var options = {
                    'ajaxtype': 'getMessages',
                    'url': jvCandidatesServiceConstant.Urls.getMessages.format(args.applicationEId),
                    'requestType': 'GET'
                 };
                 args.headers = {'Content-Type':'application/json; charset=UTF-8'};
                 createRequestObject(args, callback, options);
            }

            // get notes
            candidatesService.getNotes = function(args, callback){
            	var options = {
                    'ajaxtype': 'getNotes',
                    'url': jvCandidatesServiceConstant.Urls.getNotes.format(args.applicationEId),
                    'requestType': 'GET'
                 };
                 args.headers = {'Content-Type':'application/json; charset=UTF-8'};
                 createRequestObject(args, callback, options);
            }

            //validate Move Modal
            candidatesService.validateMoveModal = function(args, callback){
                var options = {
                    'ajaxtype': 'validateMoveModal',
                    'url': jvCandidatesServiceConstant.Urls.validateMoveModal.format(args.data, args.destinationJobId),
                    'requestType': 'GET'
                };
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args,callback,options);
            };

            candidatesService.offerReject = function(args, callback) {
                var options = {
                    'ajaxtype': 'offerRejectModal',
                    'url': jvCandidatesServiceConstant.Urls.offerReject.format(args.applicationEId, args.stateEId, args.dispositionEId),
                    'requestType': 'POST'
                };
                args = null;
                createRequestObject(args, callback, options);
            };

            candidatesService.getApplicationSummary = function(args, callback){
                var options = {
                    'ajaxtype': 'getApplicationSummary',
                    'url': jvCandidatesServiceConstant.Urls.getApplicationSummary.format(args.applicationEId),
                    'requestType': 'GET'
                 };
                 args.headers = {'Content-Type':'application/json; charset=UTF-8'};
                 createRequestObject(args, function(data){callback(data.data);}, options);
            };

            candidatesService.getApplicationCommunicationCount = function(args, callback){
                var options = {
                    'ajaxtype': 'getApplicationCommunicationCount',
                    'url': jvCandidatesServiceConstant.Urls.CommunicationCount.format(args.applicationEId),
                    'requestType': 'GET'
                 };
                 args.headers = {'Content-Type':'application/json; charset=UTF-8'};
                 createRequestObject(args, function(data){callback(data.data);}, options);
            };
            candidatesService.unlinkLinkedInProfile = function(args){
                var _unlinkLinkedInProfileObjects ={};
                _unlinkLinkedInProfileObjects['url'] = jvCandidatesServiceConstant.Urls.unlinkLinkedInProfile.format(args.applicationId,args.contactEid,args.memberToken,args.unlink),
                _unlinkLinkedInProfileObjects['ajaxtype'] = "unlinkLinkedInProfile";
                var requestPromise = makeAjaxCall(_unlinkLinkedInProfileObjects);
                requestPromise.then(function(results){
                });
           };

           candidatesService.getLinkedInCandidateSyncStatus = function(args,callback){
               var _syncStatusObject = {};
               _syncStatusObject["url"] = jvCandidatesServiceConstant.Urls.linkedInCandidateSyncStatus.format(args.applicationId,args.contactEid);
               _syncStatusObject["ajaxtype"] = "linkedInCandidateSyncStatus";
              var _getSyncStatus = makeAjaxCall(_syncStatusObject);
              _getSyncStatus.then(function( results ){
                callback(results.data);
              });
          };

          candidatesService.syncCandidateToLinkedIn = function(args,callback){
              var _syncStatusObject ={};
              _syncStatusObject["url"] = jvCandidatesServiceConstant.Urls.syncCandidateToLinkedIn.format(args.applicationId,args.contactEid);
              _syncStatusObject["ajaxtype"] = "SyncCandidateToLinkedIn";
              var _getSyncStatus = makeAjaxCall(_syncStatusObject);
              _getSyncStatus.then(function( results ){
                 callback(results.data);
              });
          };
          candidatesService.getCoverPageDetails = function(args, callback) {
            var options = {
                'ajaxtype': 'getCoverPageDetails',
                'url': jvCandidatesServiceConstant.Urls.getCoverPageDetails.format(args.applicationEId),
                'requestType': 'GET'
            };
            createRequestObject(args,callback,options);
          };
          candidatesService.getCoverPageFile = function(args, callback) {
            var options = {
                'ajaxtype': 'getCoverPageFile',
                'url': jvCandidatesServiceConstant.Urls.getCoverPageFile.format(args.applicationEId),
                'requestType': 'GET'
            };
            createRequestObject(args,callback,options);
          };
          return candidatesService;

}]);
